// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_8Hc","cls2":"ProfilePdfPackCard-cls2_tir ProfilePdfPackCard-cls1_8Hc"};